import { useEffect, useState } from "react";
import servicioToken from "../../../servicios/servicioToken";
import Autenticador from "../../../servicios/Autenticador";
import servicioUsuario from "../../../servicios/servicioUsuario";
import VerificadorDeSesion from "../VerificadorDeSesion/VerificadorDeSesion";

const Autorizador = ({ children }) => {
  const [usuarioAutorizado, setUsuarioAutorizado] = useState(null);

  useEffect(() => {
    const verificarAutorizacion = async () => {
      const token = servicioToken.obtenerToken();

      if (!token) {
        Autenticador.AutenticarUsuario();
        return;
      }

      const usuario = await servicioUsuario.obtenerUsuarioDelSistema();
      const tieneAutorizacion = usuario?.roles?.length;

      if (!tieneAutorizacion) {
        Autenticador.cerrarSesionAccesoDenegado();
        return;
      }

      setUsuarioAutorizado(usuario);
    };

    verificarAutorizacion();
  }, []);

  return usuarioAutorizado ? (
    <VerificadorDeSesion>{children}</VerificadorDeSesion>
  ) : null;
};

export default Autorizador;
